import { render } from "./DropdownVerticalLabel.vue?vue&type=template&id=1d6ad607&scoped=true"
import script from "./DropdownVerticalLabel.vue?vue&type=script&lang=js"
export * from "./DropdownVerticalLabel.vue?vue&type=script&lang=js"

import "./DropdownVerticalLabel.vue?vue&type=style&index=0&id=1d6ad607&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6ad607"]])

export default __exports__